import { Button, VText } from '@vake/ui-kit';
import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useInput } from '../pages/Report/components/useInput';
import { InputFieldTW } from '../shared/styles/InputFields';
import { useAuth } from './AuthProvider';

//Validation:
const required = (text: string, fieldName: string) => {
    if (text) {
        return '';
    }
    return `${fieldName} er obligatorisk`;
};

export const Login: FC = () => {
    const { token, login } = useAuth();
    const [failedLogin, setFailedLogin] = useState<boolean | undefined>(undefined);
    const navigate = useNavigate();
    const location = useLocation();
    const origin = location.state?.from?.pathname || '/';

    useEffect(() => {
        document.title = 'Log in';
    }, []);

    useEffect(() => {
        if (token) {
            navigate(origin);
        }
    }, [token, navigate, origin]);

    const username = useInput('', 'Username', [required]);
    const password = useInput('', 'Password', [required]);

    const submitLoginForm = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        login(username.value, password.value, (loginFailed: boolean) => setFailedLogin(loginFailed));
        resetFields();
    };
    const resetFields = () => {
        username.reset();
        password.reset();
    };

    return (
        <div className="flex items-center justify-center h-screen w-fill">
            <div className="flex flex-col gap-2">
                <VText variant="H1">Login</VText>
                <VText>Submit username and password to get access to the report.</VText>
                <form onSubmit={(e) => submitLoginForm(e)}>
                    <div className="flex gap-2">
                        <InputFieldTW
                            id="username"
                            type="username"
                            placeholder="Input username"
                            error={failedLogin}
                            {...username.bind}
                        ></InputFieldTW>
                        <InputFieldTW
                            id="password"
                            type="password"
                            placeholder="Input password"
                            error={failedLogin}
                            {...password.bind}
                        ></InputFieldTW>
                    </div>
                    <Button type="submit" text="log in"></Button>
                </form>
                {failedLogin && <VText>Login failed. Incorrect username or password.</VText>}
                <VText variant="D1">
                    If you already are a user and do not have a username and password, please contact us by{' '}
                    <a href="mailto:connect@vake.ai">email</a> and you will get access. If you would like to become a
                    user, please{' '}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://calendly.com/vake/vake-intro"
                        className="underline"
                    >
                        book a meeting with us.
                    </a>
                </VText>
            </div>
        </div>
    );
};
